import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function CompanyRoute({ children }) {
	const location = useLocation();
	const companyToken = localStorage.getItem('companyToken');

	if (!companyToken) {
		return <Navigate to="/company/login" replace state={{ from: location }} />;
	}
	return children;
}


